import imageUrlBuilder from '@sanity/image-url';
import { Sanity$Image } from '../../types/sanityImage';
import { getSanityClientConfig } from './sanityClient';

const DEFAULT_QUALITY = 75;

/**
 * Image size recommendations from
 *  https://developers.facebook.com/docs/sharing/best-practices
 * and https://iamturns.com/open-graph-image-size/
 */
export const IMAGE_WIDTH = 1200;
export const IMAGE_HEIGHT = 630;

function getUrlBuilder(image: Sanity$Image) {
  const { asset } = image;
  const urlBuilder = imageUrlBuilder(getSanityClientConfig());

  return urlBuilder.image(asset).auto('format');
}

export function getMetaImageUrl(image: Sanity$Image | null): string | null {
  if (!image?.asset) {
    return null;
  }

  const urlBuilder = getUrlBuilder(image);
  return urlBuilder.width(IMAGE_WIDTH).height(IMAGE_HEIGHT).quality(50).url();
}

export function getImageUrl(image: Sanity$Image | null): string | null {
  if (!image?.asset) {
    return null;
  }

  const urlBuilder = getUrlBuilder(image);
  return urlBuilder.quality(DEFAULT_QUALITY).url();
}
